<div [ngClass]="{ illustration: isIllustration }">
  <img alt="Utstyr" [src]="productInformation?.imageSource" />
</div>
<p class="manufacturer">{{ productInformation?.manufacturer }}</p>
<p class="name">{{ productInformation?.name }}</p>
<ul>
  @for (usp of productInformation?.uniqueSellingPoints; track usp) {
    <li>{{ usp }}</li>
  }
</ul>
@if (productInformation?.additionalInformationUrl; as url) {
  <a data-testid="webshop-equipment-link" target="_blank" [href]="url">Les mer i nettbutikken</a>
}
